import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

/**
 * Confirmation shown before removing a property option that is filled on one or
 * more candidaturas — removing it erases that value from those candidaturas.
 * Driven by the `pendingRemoval` state from usePropertyOptions.
 */
export function RemoveOptionConfirmDialog({
  pending,
  onConfirm,
  onCancel,
  isPending,
}: {
  pending: { optionId: string; affectedCount: number } | null;
  onConfirm: () => void;
  onCancel: () => void;
  isPending: boolean;
}) {
  return (
    <AlertDialog open={!!pending} onOpenChange={(open) => !open && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Remover esta opção?</AlertDialogTitle>
          <AlertDialogDescription>
            Esta opção está preenchida em{" "}
            <strong>
              {pending?.affectedCount} candidatura{pending?.affectedCount === 1 ? "" : "s"}
            </strong>
            . Remover a opção vai apagar esse valor dessas candidaturas. Esta ação não pode ser
            desfeita.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            onClick={onConfirm}
            disabled={isPending}
          >
            Remover mesmo assim
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
